import { TEmVatReportListItem } from 'redux/reducers/emVatReports/types';
import { EEmVatReportType, EM_VAT_REPORT_TYPE_LABEL } from 'redux/reducers/emVatReports/constants';
import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { DATE_FILTER, DATE_RANGE_FILTER } from 'ui/EasTable/constants';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';

export const tableStructure: TTableStructure<keyof TEmVatReportListItem>[] = [
	{
		name: 'ID',
		selector: 'id' as keyof TEmVatReportListItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		key: true,
	},
	{
		name: 'EM ID',
		selector: 'emId' as keyof TEmVatReportListItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'EM',
		selector: 'fullName' as keyof TEmVatReportListItem,
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.EM,
		align: ETableStructureAlign.LEFT,
		value: (item: TEmVatReportListItem) => ({ id: item.emId, name: item.fullName }),
	},
	{
		name: 'Report Type',
		selector: 'reportName' as keyof TEmVatReportListItem,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Report Type',
		selector: 'reportType' as keyof TEmVatReportListItem,
		show: false,
		sortable: true,
		filterable: true,
		filter: [
			[EEmVatReportType.OSS_UNION, EM_VAT_REPORT_TYPE_LABEL[EEmVatReportType.OSS_UNION]],
			[EEmVatReportType.OSS_NON_UNION, EM_VAT_REPORT_TYPE_LABEL[EEmVatReportType.OSS_NON_UNION]],
			[EEmVatReportType.DOMESTIC, EM_VAT_REPORT_TYPE_LABEL[EEmVatReportType.DOMESTIC]],
			[
				EEmVatReportType.GIFTCARD_SCHEME,
				EM_VAT_REPORT_TYPE_LABEL[EEmVatReportType.GIFTCARD_SCHEME],
			],
			[EEmVatReportType.B2B, EM_VAT_REPORT_TYPE_LABEL[EEmVatReportType.B2B]],
			[EEmVatReportType.OSS_IMPORT, EM_VAT_REPORT_TYPE_LABEL[EEmVatReportType.OSS_IMPORT]],
			[
				EEmVatReportType.NON_EU_COUNTRY_IMPORT,
				EM_VAT_REPORT_TYPE_LABEL[EEmVatReportType.NON_EU_COUNTRY_IMPORT],
			],
			[EEmVatReportType.FC_REP, EM_VAT_REPORT_TYPE_LABEL[EEmVatReportType.FC_REP]],
		],
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Report Sub Type',
		selector: 'reportSubType' as keyof TEmVatReportListItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Report month',
		selector: 'reportMonth' as keyof TEmVatReportListItem,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Report Period Start',
		selector: 'periodStart' as keyof TEmVatReportListItem,
		show: true,
		sortable: true,
		filterable: false,
		filter: DATE_FILTER,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Report Period End',
		selector: 'periodEnd' as keyof TEmVatReportListItem,
		show: true,
		sortable: true,
		filterable: false,
		filter: DATE_FILTER,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Duration',
		selector: 'duration' as keyof TEmVatReportListItem,
		show: true,
		sortable: true,
		filterable: true,
		filter: DATE_RANGE_FILTER,
		type: ETableStructureType.DATE_RANGE,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},

	{
		name: 'Included orders',
		selector: 'orderCount' as keyof TEmVatReportListItem,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Non-EU Country',
		selector: 'nonEuCountry' as keyof TEmVatReportListItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'URL',
		selector: 'url' as keyof TEmVatReportListItem,
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'actions' as keyof TEmVatReportListItem,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		buttons: [{ name: 'download', icon: EIconButtons.CLOUD_DOWNLOAD }],
		buttonFilter: (item: TEmVatReportListItem) => {
			const buttons = [];
			if (item.url) {
				buttons.push({
					name: 'download',
					label: 'Download report',
					icon: EIconButtons.CLOUD_DOWNLOAD,
				});
			}
			return buttons;
		},
	},
];
